import React from 'react';
import {withStyles, Card, Icon, IconButton, Typography} from '@material-ui/core';

const RankingWidget = ({data, title, column1Name = '', column2Name = ''}) => {
    return (
        <Card className="w-full rounded-8 shadow-none border-1">

            <div className="p-16 pr-4 flex flex-row items-center justify-between">

                <Typography className="h1 pr-16">{title}</Typography>

                <div>
                    <IconButton aria-label="more">
                        <Icon>more_vert</Icon>
                    </IconButton>
                </div>
            </div>

            <table className="simple clickable">
                <thead>
                    <tr>
                        <th></th>
                        <th className="text-right">{column1Name}</th>
                        <th className="text-right">{column2Name}</th>
                    </tr>
                </thead>
                <tbody>
                    {data.rows.map(row => (
                        <tr key={row.title}>
                            <td>{row.title}</td>
                            <td className="text-right">{row.column1}</td>
                            <td className="text-right">{row.column2}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/*<Divider className="card-divider w-full"/>*/}

            {/*<div className="p-8 pt-16 flex flex-row items-center">*/}
            {/*    <Button>GO TO CAMPAIGNS</Button>*/}
            {/*</div>*/}
        </Card>
    );
};

export default withStyles(null, {withTheme: true})(RankingWidget);



// WEBPACK FOOTER //
// ./src/main/content/analytics/widgets/RankingWidget.js